import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_URL;

const reportUnmappedRoute = async (routeDetails, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const url = `${baseUrl}/api/userReports/unmappedRoute`;

    return (await axios.post(url, routeDetails, config)).data;
};

const reportMissingStation = async (routeDetails, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const url = `${baseUrl}/api/userReports/missingStation`;

    return (await axios.post(url, routeDetails, config)).data;
};

const reportMessage = async (messageDetails, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const url = `${baseUrl}/api/userReports/message`;

    return (await axios.post(url, messageDetails, config)).data;
};

const userReportService = {
    reportUnmappedRoute,
    reportMissingStation,
    reportMessage,
};

export default userReportService;